const SocialEndpoints = {
  linkedin: {
    isConnected: "/social/linkedin/isconnected",
    connect: "/social/linkedin/connect",
    disconnect: "/social/linkedin/disconnect",
  },
  youtube: {
    isConnected: "/social/youtube/isconnected",
    connect: "/social/youtube/connect",
    disconnect: "/social/youtube/disconnect",
  },
  meta: {
    isConnected: "/social/meta/isconnected",
    connect: "/social/meta/connect",
    disconnect: "/social/meta/disconnect",
    accounts: "/social/meta/accounts",
    setActiveAccount: "/social/meta/accounts/active",
  },
  tiktok: {
    authUrl: "/social/tiktok/auth-url",
    isConnected: "/social/tiktok/isconnected",
    connect: "/social/tiktok/connect",
    disconnect: "/social/tiktok/disconnect",
  },
  connections: {
    index: "social/requests/",
    edit: "social/requests/edit",
    show: "social/requests/show/",
    delete: "social/requests/delete/"
  },
  settings: {
    presentation: "social/settings/presentation",
    teleprompter: "social/settings/teleprompter",
    platformDefaults: "social/settings/platform-defaults",
    /** the user's personal default title CSS (GET + PUT) */
    overlayCss: "social/settings/overlay-css",
  },
  posts: {
    index: "social/post/",
    plannedOnly: "social/post/plannedonly",
    postedOnly: "social/post/postedonly",
    drafts: "social/post/drafts",
    new: "social/post/new",
    edit: "social/post/edit",
    delete: "social/post/delete/",
    show: "social/post/show/",
    setDraft: "social/post/setDraft/",
    markInProgress: "social/post/markinprogress/",
    setReady: "social/post/setready/",
    schedule: {
      indexAllForPost: "social/post/schedule/all/",
      index: "social/post/schedule/",
      indexbymonth: "social/post/schedule/",
      new: "social/post/schedule/new",
      edit: "social/post/schedule/edit",
      show: "social/post/schedule/show/",
      delete: "social/post/schedule/delete/",
      failed: "social/post/schedule/failed",
      errorDelete: "social/post/schedule/error-delete/",
      /** POST {publish_as, local_user_time, timezone, platforms} + postId: plan on another member's account */
      planFor: "social/post/schedule/planfor/",
      /** GET + postId: group members this post may be planned for */
      planForCandidates: "social/post/schedule/planfor/candidates/",
      approvals: {
        inbox: "social/post/schedule/approvals/inbox",
        approve: "social/post/schedule/approvals/approve/",
        reject: "social/post/schedule/approvals/reject/",
        /** PUT + scheduleId: take an approval back before publishing; waits for a decision again */
        withdraw: "social/post/schedule/approvals/withdraw/",
      },
    },
    publish: "social/post/publish/",
    platformSettings: "social/post/",   // + {id}/platform-settings
    postImage: "social/post/postimage/",
    ai: {
      finishPost: "ai/content/finishPost/",
      checkText: "ai/content/check/",
      createContentVariant: "ai/content/createcontentvariant/",
      createTypeVariant: "ai/content/createtypevariant/",
      createEducationalBlogpost: "ai/content/createeducationalblogpost/",
      createPostFromBulletpoints: "ai/content/createpostfrombulletpoints/",
      creatAassistedPost: "ai/content/createassistedpost/",
      createNewPost: "ai/content/createnewpost",
      createIdeas: "ai/content/createIdeas",
    },
    imageAi: {
      autoenhance: "ai/images/enhanceImage/",
      denoise: "ai/images/denoise/",
      facelift: "ai/images/facelift/",
    },
    planningAi: {
      assistant: "ai/content/planmonth"
    },
    ideas: {
      index: "social/idea/",
      new: "social/idea/new",
      edit: "social/idea/edit",
      delete: "social/idea/delete/",
      show: "social/idea/show/",
      convert: "social/idea/convert/",
    },
    poll: {
      new: "social/poll/new/",
      edit: "social/poll/edit",
      delete: "social/poll/delete/",
    },
    tags: {
      list: "tag",
      new: "tag/new",
    },
    contentPillars: {
      index: "social/contentpillar/",
      new: "social/contentpillar/new",
      edit: "social/contentpillar/edit",
      show: "social/contentpillar/show/",
      showposts: "social/contentpillar/showposts/",
      delete: "social/contentpillar/delete/",
      deleteFromPillar: "social/contentpillar/removeFromPillar/",
    },
    unpublished: "social/post/unpublished",
    publishedOnly: "social/post/published",
    unplanned: "social/post/recycle",
    clone: "social/post/clone/",
    top: "social/post/top",
    dataField: "posts",
    scheduledDataField: "schedules",
  },
  jobs: {
    index: "social/job/",
    show: "social/job/show/",
    status: "social/job/", // + {id}/status  (PATCH) — board is read-only for now
    delete: "social/job/delete/",
    dataField: "jobs",
  },
};

export default SocialEndpoints;
